import type { FC } from 'react';

export const SkioLogo: FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'w-8 h-8 flex items-center justify-center'}>
    <img
      src="/skio-logo.png"
      alt="Skio"
      className="w-full h-full object-contain"
    />
  </div>
);
